import { FC, ReactNode } from 'react';
import cx from 'classnames';

import emojiBigUp from '@/assets/emoji/bigup.png';
import emojiThinking from '@/assets/emoji/thinking.png';
import emojiHand from '@/assets/emoji/hand.png';
import emojiPintUp from '@/assets/emoji/pointup.png';
import emojiClock from '@/assets/emoji/clock.png';
import emojiAttention from '@/assets/emoji/attention.png';
import emojiWarning from '@/assets/emoji/warning.png';
import emojiClean from '@/assets/emoji/clean.png';
import emojiConfetti from '@/assets/emoji/confetti.png';
import styles from './EmojiDisplay.module.sass';

const EmojiMap = {
  '👍': emojiBigUp,
  '🤔': emojiThinking,
  '🤚': emojiHand,
  '👆': emojiPintUp,
  '⏰': emojiClock,
  '☝': emojiAttention,
  '⚠️': emojiWarning,
  '🧹': emojiClean,
  '🎉': emojiConfetti,
};

interface EmojiDisplayProps {
  emoji: string | ReactNode;
  className?: string;
}

const EmojiDisplay: FC<EmojiDisplayProps> = ({ emoji, className }) => {
  const imageUrl = EmojiMap[emoji as keyof typeof EmojiMap];
  const classes = cx(styles.emoji, className);

  return (
    <span className={classes}>
      {imageUrl ? <img src={imageUrl} alt="" /> : emoji}
    </span>
  );
};

export default EmojiDisplay;
